// packages/app/src/components/solutions-agent/ChatMessage.tsx
import { makeStyles, Button } from '@material-ui/core';
import { ChatMessage as ChatMessageType } from './types';

const useStyles = makeStyles(theme => ({
  row: {
    display: 'flex',
    marginBottom: theme.spacing(1.5),
  },
  user: {
    justifyContent: 'flex-end',
  },
  assistant: {
    justifyContent: 'flex-start',
  },
  system: {
    justifyContent: 'center',
  },
  bubble: {
    maxWidth: '80%',
    padding: theme.spacing(1.25, 1.75),
    borderRadius: 12,
    whiteSpace: 'pre-wrap',
    wordBreak: 'break-word',
  },
  userBubble: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
  },
  assistantBubble: {
    backgroundColor: theme.palette.background.paper,
    border: `1px solid ${theme.palette.divider}`,
  },
  systemBubble: {
    backgroundColor: 'transparent',
    color: theme.palette.text.secondary,
    fontSize: 13,
    textAlign: 'center',
    maxWidth: '90%',
  },
  actions: {
    marginTop: theme.spacing(1),
    display: 'flex',
    gap: theme.spacing(1),
    flexWrap: 'wrap',
  },
}));

interface ChatMessageProps {
  message: ChatMessageType;
  proposalUrl?: string;
  zipUrl?: string;
}

export const ChatMessageBubble = ({
  message,
  proposalUrl,
  zipUrl,
}: ChatMessageProps) => {
  const classes = useStyles();
  const isCompleteMsg = message.id.startsWith('complete-');
  const isReviewMsg = message.id.startsWith('review-');
  const showActions =
    (isReviewMsg && Boolean(proposalUrl)) ||
    (isCompleteMsg && Boolean(proposalUrl || zipUrl));

  return (
    <div
      className={`${classes.row} ${
        message.role === 'user'
          ? classes.user
          : message.role === 'system'
          ? classes.system
          : classes.assistant
      }`}
    >
      <div
        className={`${classes.bubble} ${
          message.role === 'user'
            ? classes.userBubble
            : message.role === 'system'
            ? classes.systemBubble
            : classes.assistantBubble
        }`}
      >
        {message.text}
        {showActions && (
          <div className={classes.actions}>
            {proposalUrl && (isReviewMsg || isCompleteMsg) && (
              <Button
                size="small"
                variant="contained"
                color="primary"
                href={proposalUrl}
                target="_blank"
                rel="noreferrer"
              >
                Open proposal HTML
              </Button>
            )}
            {isCompleteMsg &&
              (zipUrl ? (
                <Button
                  size="small"
                  variant="outlined"
                  href={zipUrl}
                  target="_blank"
                  rel="noreferrer"
                >
                  Download artifacts zip
                </Button>
              ) : (
                <Button size="small" variant="outlined" disabled>
                  Zip coming
                </Button>
              ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default ChatMessageBubble;
